var m = require('mithril');
var prop = require('mithril/stream');
var Model = require('../libs/Model');
var treeDashboard = require('./treeDashboard');
var treeLocations = require('./treeLocations');

var Dashboard = Object.assign(require('../../../../models/dashboards/dashboard'), Model);
var DashboardTree = {root: Dashboard, name: 'Home', leafClass: 'Dashboard', edgeClass: 'Contains', ancestorClass: 'ancestors', '@id': '/api/v1/dashboardonly/'};

var treeDashboardsAndLocations = {};

treeDashboardsAndLocations.DestinationTypes = {
  DASHBOARD: 'dashboard',
  LOCATION: 'location'
};

treeDashboardsAndLocations.oninit = function (vnode) {
  var ctrl = this;
  ctrl.selector = vnode.attrs.selector || prop(null);
  ctrl.onSelect = vnode.attrs.onSelect || function () {};
  ctrl.dashboardLabel = vnode.attrs.dashboardLabel || 'parent dashboard';
  ctrl.dashboardTrees = vnode.attrs.dashboardTrees || [DashboardTree];
  ctrl.showDashboards = vnode.attrs.showDashboards !== false;
  ctrl.showLocations = vnode.attrs.showLocations !== false;
  ctrl.availableTabs = [];
  if (ctrl.showDashboards) {
    ctrl.availableTabs.push(treeDashboardsAndLocations.DestinationTypes.DASHBOARD);
  }
  if (ctrl.showLocations) {
    ctrl.availableTabs.push(treeDashboardsAndLocations.DestinationTypes.LOCATION);
  }
  if (ctrl.availableTabs.length === 0) {
    ctrl.availableTabs.push(treeDashboardsAndLocations.DestinationTypes.DASHBOARD);
    ctrl.showDashboards = true;
  }
  ctrl.activeTab = prop(ctrl.availableTabs[0]);

  ctrl.dashboardSelection = prop({});
  ctrl.locationSelection = prop({});

  ctrl.setInitialSelection = function () {
    var currentSelection = ctrl.selector() || {};
    if (ctrl.showDashboards && currentSelection.type === treeDashboardsAndLocations.DestinationTypes.DASHBOARD && currentSelection.record) {
      ctrl.dashboardSelection(currentSelection.record);
      ctrl.activeTab(treeDashboardsAndLocations.DestinationTypes.DASHBOARD);
    } else if (ctrl.showLocations && currentSelection.type === treeDashboardsAndLocations.DestinationTypes.LOCATION && currentSelection.record) {
      ctrl.locationSelection(currentSelection.record);
      ctrl.activeTab(treeDashboardsAndLocations.DestinationTypes.LOCATION);
    } else {
      ctrl.dashboardSelection({});
      ctrl.locationSelection({});
      ctrl.activeTab(ctrl.availableTabs[0]);
    }
  };

  ctrl.dashboardSelector = function (value) {
    if (arguments.length) {
      ctrl.dashboardSelection(value);
      ctrl.locationSelection({});
      ctrl.selector({
        type: treeDashboardsAndLocations.DestinationTypes.DASHBOARD,
        record: value
      });
      ctrl.onSelect(treeDashboardsAndLocations.DestinationTypes.DASHBOARD, value);
      ctrl.activeTab(treeDashboardsAndLocations.DestinationTypes.DASHBOARD);
    }
    return ctrl.dashboardSelection();
  };

  ctrl.locationSelector = function (value) {
    if (arguments.length) {
      ctrl.locationSelection(value);
      ctrl.dashboardSelection({});
      ctrl.selector({
        type: treeDashboardsAndLocations.DestinationTypes.LOCATION,
        record: value
      });
      ctrl.onSelect(treeDashboardsAndLocations.DestinationTypes.LOCATION, value);
      ctrl.activeTab(treeDashboardsAndLocations.DestinationTypes.LOCATION);
    }
    return ctrl.locationSelection();
  };

  ctrl.selectTab = function (tab) {
    if (ctrl.availableTabs.includes(tab)) {
      ctrl.activeTab(tab);
    }
  };

  ctrl.setInitialSelection();
};

treeDashboardsAndLocations.view = function () {
  var ctrl = this;
  var tabs = ctrl.availableTabs.map(function (tab) {
    return {
      label: tab === treeDashboardsAndLocations.DestinationTypes.DASHBOARD ? 'Dashboards' : 'Locations',
      value: tab
    };
  });
  var showTabs = tabs.length > 1;
  var activeTab = ctrl.activeTab();
  return m('div', [
    showTabs ? m('label.db.mb2.fw6', 'Select new parent type:') : null,
    showTabs ? m('div.flex.flex-wrap.mb3', tabs.map(function (tab, idx) {
      var isActive = activeTab === tab.value;
      var tabClass = 'div.flex-auto.f4.ba.bw1.ph3.pv2.tc.v-btm.pointer' + (isActive ? '.bg-mid-gray' : '');

      return m(tabClass, {
        key: tab.value,
        style: {
          flex: '1 1 0%',
          minWidth: '0',
          marginRight: idx === tabs.length - 1 ? '0' : '0.5rem',
          marginBottom: '0.5rem',
        },
        onclick: function () {
          ctrl.selectTab(tab.value);
        }
      }, tab.label);
    })) : null,
    ctrl.showDashboards && activeTab === treeDashboardsAndLocations.DestinationTypes.DASHBOARD ?
      m('div.mb4',
        m(treeDashboard, {trees: ctrl.dashboardTrees, selector: ctrl.dashboardSelector, label: ctrl.dashboardLabel})
      )
      :
      null,
    ctrl.showLocations && activeTab === treeDashboardsAndLocations.DestinationTypes.LOCATION ?
      m('div',
        m(treeLocations, {selector: ctrl.locationSelector})
      )
      :
      null
  ]);
};

module.exports = treeDashboardsAndLocations;
